import React from 'react'

import { Label, Row, Col, Button, Card, CardBody, Input } from 'reactstrap'
import Slider from 'rc-slider'


const createSliderWithTooltip = Slider.createSliderWithTooltip;
const Range = createSliderWithTooltip(Slider.Range);


export const Filter = props => {

    const { bedrooms, accommodates, occupacity, onChange, onChangeBedrooms, onChangeAccommodates, onChangeOccupacity, onSubmit } = props

    return (
        <Row>
            <Col>
                <Card>
                    <CardBody>
                        <h3>Propiedades</h3>
                        <form onSubmit={onSubmit}>
                            <Row>
                                <Col md={2}>
                                    <Label>Habitaciones</Label>
                                    <Row>
                                        <Col>
                                            <Range
                                                min={1}
                                                max={16}
                                                marks={{ 1: 1, 16: 16 }}
                                                defaultValue={bedrooms}
                                                tipFormatter={value => `${value}`}
                                                onChange={onChangeBedrooms}
                                            />
                                        </Col>
                                    </Row>
                                </Col>
                                <Col md={1}></Col>
                                <Col md={2}>
                                    <Label>Huéspedes</Label>
                                    <Row>
                                        <Col>
                                            <Range
                                                min={1}
                                                max={16}
                                                marks={{ 1: 1, 16: 16 }}
                                                defaultValue={accommodates}
                                                tipFormatter={value => `${value}`}
                                                onChange={onChangeAccommodates}
                                            />
                                        </Col>
                                    </Row>
                                </Col>
                                <Col md={1}></Col>
                                <Col md={2}>
                                    <Label>Tipo de habitación</Label>
                                    <div className="custom-control custom-checkbox">
                                        <input
                                            id="entire_home"
                                            name="entire_home"
                                            type="checkbox"
                                            className="custom-control-input"
                                            onChange={onChange}
                                            defaultChecked
                                        />
                                        <Label className="custom-control-label" for="entire_home">Casa entera</Label>
                                    </div>
                                    <div className="custom-control custom-checkbox">
                                        <Input
                                            id="private_room"
                                            name="private_room"
                                            type="checkbox"
                                            className="custom-control-input"
                                            onChange={onChange}
                                            defaultChecked
                                        />
                                        <Label className="custom-control-label" for="private_room">Privada</Label>
                                    </div>
                                    <div className="custom-control custom-checkbox">
                                        <Input
                                            id="shared_room"
                                            name="shared_room"
                                            type="checkbox"
                                            className="custom-control-input"
                                            onChange={onChange}
                                            defaultChecked
                                        />
                                        <Label className="custom-control-label" for="shared_room">Compartida</Label>
                                    </div>
                                </Col>
                                <Col md={1}></Col>
                                <Col md={2}>
                                    <Label>Ocupación</Label>
                                    <Row>
                                        <Col>
                                            <Range
                                                min={0}
                                                max={100}
                                                marks={{ 0: 0, 100: 100 }}
                                                defaultValue={occupacity}
                                                tipFormatter={value => `${value}`}
                                                onChange={onChangeOccupacity}
                                            />
                                        </Col>
                                    </Row>

                                </Col>
                            </Row>
                            <hr />
                            <Row>
                                <Col>
                                    <Button block color="info">
                                        <i className="fa fa-search"></i>
                                        {" "}
                                        Filtrar
                                    </Button>
                                </Col>
                            </Row>
                        </form>
                    </CardBody>
                </Card>
            </Col>
        </Row>
    )
}